import React, { useEffect } from "react";
import { Table } from 'antd';
import { connect } from "react-redux";
import { 
	getPayrunDtrList, doPayrunDtrUpdate
} from "../../../../redux/payrun/payrunState";
import InputSaveOnChange from "components/fields/InputSaveOnChange";

const PayrunDtrTable = (props) => {
	
  const { payrunDtrList, getPayrunDtrs, payrunId, mode, updateDtrValue } = props;
  
  const doSaveDtrValueChanged = (value, record, field, paycodeId) => {
    updateDtrValue({'id':record.pdt_id, value, field});
  }
  const columns = [
    {
        title: `Date`,
        dataIndex: 'pdt_date',
        key: 'pdt_date',
        width: 100, 
        fixed: 'left',    
    },
    {
        title: `Schedule Type`,
        dataIndex: 'pdt_schedule_type_name',
        key: 'pdt_schedule_type_name',
        width: 110,
       
    },
    {
        title: `Shift`,
        dataIndex: 'pdt_start_date_time',
        key: 'pdt_start_date_time',
        width: 150,
        render:(pdt_start_date_time, record) => <div>
        	{pdt_start_date_time ? 
        	(<>
				<div>{pdt_start_date_time}</div>
	        	<div>{record.pdt_end_date_time}</div>
        	</>) 
        	: ''}
        	</div> 
       
    },
    {
        title: `Punch IN/OUT`,
        dataIndex: 'pdt_date_time_in',
        key: 'pdt_date_time_in',
        width: 150,
        render:(pdt_date_time_in, record) => <div>
	        {pdt_date_time_in ? 
	        (<>
		        <div>{pdt_date_time_in}</div>
		        <div>{record.pdt_date_time_out}</div>
	        </>) 
	        : ''}
	        </div>
       
    },
    {
        title: `Work Hours`,
        dataIndex: 'pdt_work_hours',
        key: 'pdt_work_hours',
        width: 90,
        render: (pdt_work_hours, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pdt_work_hours" 
                    mode={mode} 
                    saveValueHandler={doSaveDtrValueChanged}
                />
        
    },
    {
        title: `Late`,
        dataIndex: 'pdt_late',
        key: 'pdt_late',
        width: 90,
        render: (pdt_late, record) => 
                <InputSaveOnChange
                    className="text-right" 
                    record={record} 
                    field="pdt_late" 
                    mode={mode}
                    saveValueHandler={doSaveDtrValueChanged}
                />
        
    },
    {
        title: `Undertime`,
        dataIndex: 'pdt_undertime',
        key: 'pdt_undertime',
        width: 90,
        render: (pdt_undertime, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pdt_undertime" 
                    mode={mode}
                    saveValueHandler={doSaveDtrValueChanged}
                />
        
    },
    {
        title: `Absence`,
        dataIndex: 'pdt_absence',
        key: 'pdt_absence',
        width: 90,
        render: (pdt_absence, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pdt_absence" 
                    mode={mode}
                    saveValueHandler={doSaveDtrValueChanged}
                />
        
    },
    {
        title: `Remarks`,
        dataIndex: 'pdt_remarks',
        key: 'pdt_remarks',
        width: 150,
        render: (pdt_absence, record) => 
                <InputSaveOnChange 
                    record={record} 
                    field="pdt_remarks" 
                    className="max-w-[150px]" 
                    mode={mode}
                    saveValueHandler={doSaveDtrValueChanged}
                    component="textarea"
                />
        
    },
    {
        title: `Total Hours`,
        dataIndex: 'pdt_work_hours',
        key: 'pdt_work_hours',
        width: 90,
        fixed: 'right',  
        
    },
    ];
	
	useEffect(() => {
	    if (payrunId > 0) {
	        getPayrunDtrs({payrunId: payrunId, paginate: 0});
	    }
	}, [getPayrunDtrs, payrunId]);
	
  	return (
  		<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
		    
  			<Table
    			dataSource={payrunDtrList} 
	        	columns={columns} 
	            rowKey={(record) => record.pnd_id}
	            pagination={false}
	            scroll={{
			      x: 1300,
			      y: 420,
			    }}
    		/>
  		</div>
  	);
};

const mapStateToProps = (state) => ({
	payrunDtrList: state.payrun.payrunDtrList?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getPayrunDtrs: (id) => dispatch(getPayrunDtrList(id)),
    updateDtrValue: (data) => dispatch(doPayrunDtrUpdate(data)),
    
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrunDtrTable);